import { observable, action } from 'mobx';
import gql from 'graphql-tag';

/**
 * update the wall level
 */
const WallsMutation = gql`
    mutation WallsMutation(
        $URLID: String!
        $RoomNum: Int!
        $RoomSection: String!
        $RoomData: String!
    ) {
        toolSubmissionMutation(
            URLID: $URLID
            RoomNum: $RoomNum
            RoomSection: $RoomSection
            RoomData: $RoomData
        ) {
            URLID
            Error
        }
    }
`;

export class WallsStore {
    appStore;

    @observable numWalls = 1;

    @observable goNext = false;

    @observable loading = false;

    @action reset() {
        this.numWalls = 1;
        this.goNext = false;
        this.page = [];
    }

    constructor(opts) {
        this.appStore = opts.appStore;
        this.currentRoomNum = opts.currentRoomNum;
    }

    getMutation(values) {
        return {
            mutation: WallsMutation,
            variables: {
                URLID: this.appStore.submissionID,
                RoomNum: this.currentRoomNum,
                RoomSection: 'walls',
                RoomData: JSON.stringify(values.walls)
            },
            fetchPolicy: 'no-cache',
            context: {
                headers: {
                    'X-CSRF-TOKEN': this.appStore.sectoken
                }
            }
        };
    }

    async save(values, form, goNext) {
        this.loading = true;
        this.appStore.updateUserData(values.walls, 'walls', this.currentRoomNum);
        this.appStore.save(this.getMutation(values), this, form, goNext);
    }
}
